import { render } from "./balances-bar-chart.vue?vue&type=template&id=544753bf&scoped=true"
import script from "./balances-bar-chart.vue?vue&type=script&lang=js"
export * from "./balances-bar-chart.vue?vue&type=script&lang=js"

import "./balances-bar-chart.vue?vue&type=style&index=0&id=544753bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544753bf"]])

export default __exports__